export default {
  SpecFrameSizeIcon: () =>
    import(
      /* webpackChunkName: "SpecFrameSizeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecFrameSizeIcon.vue'
    ),
  SpecGroupsetIcon: () =>
    import(
      /* webpackChunkName: "SpecGroupsetIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecGroupsetIcon.vue'
    ),
  SpecItemCarrierIcon: () =>
    import(
      /* webpackChunkName: "SpecItemCarrierIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecItemCarrierIcon.vue'
    ),
  SpecBatteryIcon: () =>
    import(
      /* webpackChunkName: "SpecBatteryIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecBatteryIcon.vue'
    ),
  SpecTravelIcon: () =>
    import(
      /* webpackChunkName: "SpecTravelIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecTravelIcon.vue'
    ),
  SpecHubIcon: () =>
    import(
      /* webpackChunkName: "SpecHubIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecHubIcon.vue'
    ),
  SpecDescriptionIcon: () =>
    import(
      /* webpackChunkName: "SpecDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecDescriptionIcon.vue'
    ),
  SpecPedalIcon: () =>
    import(
      /* webpackChunkName: "SpecPedalIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecPedalIcon.vue'
    ),
  SpecBrakeIcon: () =>
    import(
      /* webpackChunkName: "SpecBrakeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecBrakeIcon.vue'
    ),
  SpecLeverIcon: () =>
    import(
      /* webpackChunkName: "SpecLeverIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecLeverIcon.vue'
    ),
  SpecTireIcon: () =>
    import(
      /* webpackChunkName: "SpecTireIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecTireIcon.vue'
    ),
  SpecGroupsetNewIcon: () =>
    import(
      /* webpackChunkName: "SpecGroupsetNewIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Groups/SpecGroupsetNewIcon.vue'
    ),
}
